export const ExchangeRateRefDateAttrPolicy  = ({
    referenceDate: {
        OPS_DATE: "Ops Date",
        DOC_DATE: "Doc Date",
    }
})